// Copyright © 2006-2020 Lexbe Inc. All rights reserved.

import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { FeatureConfig } from '../models/feature-config.model';
import { ErrorHandlerService } from './error-handler.service';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeatureConfigService implements OnDestroy {
  private _featureConfig$ = new ReplaySubject<FeatureConfig>(1);
  get featureConfig$(): Observable<FeatureConfig> {
    return this._featureConfig$.asObservable();
  }

  interval;

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) {
    this.refreshFeatureConfig();
    this.interval = setInterval(() => {
      this.refreshFeatureConfig();
    }, 900000); // 15 minutes
  }

  ngOnDestroy() {
    clearInterval(this.interval);
    this._featureConfig$.complete();
  }

  private refreshFeatureConfig(): void {
    this.http.get<FeatureConfig>(`${this.appConfigService.getConfig().webApi}/api2/FeatureConfigs`)
      .pipe(catchError(this.errorHandler.handleError<FeatureConfig>(`get FeatureConfigs`)))
      .subscribe(sc => this._featureConfig$.next(sc));
  }
}
